export default __webpack_public_path__ + "static/media/Scenery11.7c03b48f.jpg";